import React, { useEffect, useMemo, useState } from "react";

import PageTitle from "../PageTitle";
import PageSearch from "../PageSearch";
import DialogBox from "../../components/dialog-box/DialogBox";
import EnhancedTable from "../table/Table";
import { useAppDispatch, useAppSelector } from "../../redux/hooks/redux-hooks";
import { displayDateFormart, isValidArr } from "../../utility/utils";
import { fetchSBGs } from "../../redux/actions/SBGActions";
import { fetchUsers } from "../../redux/actions/UserActions";
import Loader from "../../components/loader/Loader";
import SBGForm from "./SBGForm";
import { SBGModel } from "../../models/SBGModel";

export type Mode = "add" | "edit";

type iData = {
  id: number;
  name: string;
  description: string;
  sbguserId: string;
  createdDate: string;
  // status: string;
};

const SBGPage = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mode, setMode] = useState<Mode>("add");
  const [editData, setEditData] = useState<SBGModel>();
  const [rootData, setRootData] = useState<iData[]>([]);
  const [filteredData, setFilteredData] = useState<iData[]>([]);

  const allSBGs = useAppSelector((state) => state.sbg.all_SBGs);
  const allUsers = useAppSelector((state) => state.user.all_Users);

  const isSbgsFetching = useAppSelector((state) => state.sbg.isSbgsFetching);

  const columns = useMemo(() => {
    return [
      {
        id: "name",
        numeric: false,
        disablePadding: false,
        label: "Name",
      },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: "Description",
      },
      {
        id: "sbguserId",
        numeric: false,
        disablePadding: false,
        label: "User",
      },
      {
        id: "createdDate",
        numeric: false,
        disablePadding: false,
        label: "Created Date",
        width: 150,
      },
      // {
      //   id: "status",
      //   numeric: false,
      //   disablePadding: false,
      //   label: "Status",
      // },
    ];
  }, []);

  //To fetch all SBGs and Users
  useEffect(() => {
    dispatch(fetchSBGs());
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    setRootData(() =>
      allSBGs.map((sbg) => {
        const user = allUsers.find((user) => user.userId === sbg.sbguserId);
        const userName = user ? `${user.firstName} ${user.lastName}` : "";
        return {
          id: sbg.sbgid,
          name: sbg.name,
          description: sbg.description,
          sbguserId: userName,
          createdDate: displayDateFormart(sbg.createdDate),
          // status: sbg.isActive ? "Active" : "Inactive",
        };
      })
    );
  }, [allSBGs, allUsers]);

  // To set filtered data on change root data
  useEffect(() => {
    setFilteredData(rootData);
  }, [rootData]);

  const handleEdit = (id: string | number) => {
    const editSBGRec = allSBGs.find((rec) => rec.sbgid === id);
    setMode("edit");
    setEditData(editSBGRec);
    setIsModalOpen(true);
  };

  const createHandler = () => {
    setMode("add");
    setEditData(undefined);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  const searchHandler = (searchVal: string): void => {
    setFilteredData(() =>
      searchVal
        ? rootData.filter((info) =>
            Object.values(info).join("").toLowerCase().includes(searchVal)
          )
        : rootData
    );
  };

  return (
    <>
      {!isValidArr(allSBGs) && isSbgsFetching ? <Loader /> : null}
      <PageTitle title="SBGs" btnText="Add SBG" onClick={createHandler} />
      <PageSearch placeholder="Search SBGs" searchHandler={searchHandler} />
      <EnhancedTable
        columns={columns}
        data={filteredData}
        handleEdit={handleEdit}
      />
      {isModalOpen && (
        <DialogBox
          isModalOpen={isModalOpen}
          modalTitle={mode === "add" ? "Create SBG" : "Edit SBG"}
          handleModalClose={handleModalClose}
        >
          <SBGForm
            mode={mode}
            data={editData}
            handleModalClose={handleModalClose}
          />
        </DialogBox>
      )}
    </>
  );
};

export default SBGPage;
